const messages = {
  title: "Preislisten",
  description:
    "Willkommen im Broschüren- und Preislistenbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Broschüren und Preislisten zu allen Produktbereichen und Pricat Dateien für Ihre Warenwirtschaft.",
  productInfo: {
    categories: {
      info: "Produkt-infos",
      priceList: "Preislisten",
      contact: "Kontakt",
    },
    page: {
      description:
        "Willkommen im Informationsbereich Rund um die Produkte von Bridgestone & Fisrestone.<br/>Hier finden Sie aktuelle Broschüren und Preislisten sowie hilfreiche Links und Formulare.",
    },
    index: {
      title: "Produktinformationen",
      description:
        "Willkommen im Informationsbereich rund um die Produkte von Bridgestone und Firestone.<br/>Hier finden Sie aktuelle Broschüren und weiterführende Materialien.",
      categories: {
        productBrochures: {
          title: "Produktbroschüren",
          description:
            "Aktuelle Bridgestone und Firestone Produktbroschüren zum Downloaden",
        },
        bDrive: {
          title: "Reifenabbildungen &<br/>Logos",
          description:
            "Aktuelle Logos, Produktabbildungen und Marketingvorlagen",
          button: "ZU B-DRIVE",
        },
        calculator: {
          title: "Spritspar<span class='text-danger'>-Rechner</span>",
          description:
            "Reifen mit optimiertem Rollwiderstand –Einsparpotentiale einfach berechnen!",
        },
        carApprovals: {
          title: "Pkw Freigaben Bridgestone",
          description:
            "Finden Sie die passenden Bridgestone Pkw-Reifen mit Zulassung",
        },
        carApprovalsFS: {
          title: "Pkw Freigaben Firestone",
          description:
            "Finden Sie die passenden Firestone Pkw-Reifen mit Zulassung",
        },
        motApprovals: {
          title: "Motorrad Freigaben",
          description:
            "Finden Sie die passenden Bridgestone Motorradreifen mit Zulassung",
        },
        dataGenereate: {
          title: "Datenblatt-Generator",
          description:
            "Tippe Sie die IPC ein und generieren Ihr eigenes Datenblatt",
        },
      },
    },
  },
  priceDescription:
    "Laden Sie aktuelle Preislisten herunter für Ihren Gebrauch.",
  pricatDescription:
    "Hier erhalten Sie Pricat Dateien für Ihre Warenwirtschaft.",
  pricat: {
    title: "Pricat",
    description:
      "Laden Sie hier CSV- und TEXT- Datensätze für Ihre Warenwirtschafts- und EDV-Systeme & Co herunter.",
  },
  pkw: {
    title: "Preislisten Pkw-, 4x4- und Transporter-Reifen",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter.",
  },
  trucksAndBuses: {
    title: "Preislisten Lkw und Busse",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul> <li>Lkw und Busse</li> </ul>",
  },
  motorcycles: {
    title: "Preislisten Motorrad-Reifen",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone Reifen herunter: <ul> <li>Motorrad</li> </ul>",
  },
  agriculture: {
    title: "Preislisten Landwirtschafts-Reifen",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul> <li>Landwirtschaft</li> </ul>",
  },
  constructionMachineryOtr: {
    title: "Preislisten Baumaschinen-/OTR-Reifen",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunte: <ul><li>Baumaschinen/OTR</li></ul>",
  },
  main: {
    title: "Preislisten",
    description:
      "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul><li>Pkw, 4x4 und Transporter</li><li>Motorrad</li><li>Lkw und Busse</li> <li>Landwirtschaft</li><li>Baumaschinen / OTR</li></ul>",
  },
  index: {
    description:
      "Willkommen im Preislistenbereich rund um die Produkte von Bridgestone und Firestone.<br/>Hier finden Sie aktuelle Preislisten zu allen Produktbereichen und Pricat Dateien für Ihre Warenwirtschaft.",
  },
};

export default {
  messages,
};
